/**
 * Whether the order is a split child. Its parent is `original_order_id`; a clone also sets that link but has no
 * `split_seq`, so only `split_seq` tells the two apart.
 *
 * @param {{ split_seq?: number|null }} [order]
 * @returns {boolean} true when the order came from a split
 */
export const isSplitChild = (order) => order?.split_seq != null;
